import { useQuery } from '@tanstack/react-query';

import { findSponsorsByName } from './utils';

import { getSponsorDataFromService } from '@utilities/sponsor';
import { competitionId } from '@utilities/WindowContext';

export const useSponsor = (name: string, compId = competitionId) => {
  const enable = !!name;
  const { data: sponsor, isFetched } = useQuery({
    queryKey: ['sponsors', compId, name],
    queryFn: ({ signal }) => getSponsorDataFromService(compId, false, signal),
    enabled: !!enable,
    placeholderData: [],
    select: (data) => findSponsorsByName(data, name),
  });

  return {
    sponsor: enable ? sponsor : null,
    loaded: isFetched || !enable,
  };
};
